<template>
  <client-only>
    <Swiper
      ref="{swiperRef}"
      :slidesPerView="slidesPerView"
      :navigation="true"
      :rewind="true"
      :spaceBetween="2"
      :modules="modules"
    >
      <SwiperSlide v-for="(d, index) in data" :key="index + 'carousel-key'">
        <slot :data="d" />
      </SwiperSlide>
    </Swiper>
  </client-only>
</template>

<script>
import "swiper/swiper-bundle.css";
// Import Swiper styles
import "swiper/css";

import "swiper/css/navigation";

import { Swiper, SwiperSlide } from "swiper/vue";
// import required modules
import { Navigation, Pagination } from "swiper/modules";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    slidesPerView: {
      // NOTE: typically handles slidesPerView with breakpoints from parent
      type: Number,
      default: 3.5,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  },
};
</script>

<style lang="css">
.swiper-button-prev,
.swiper-button-next {
  @apply shadow hover:shadow-md rounded-full bg-white size-8;
}
.swiper-button-prev::after,
.swiper-button-next::after {
  @apply text-lg p-2 text-black;
}

.swiper-slide {
  display: flex;
  align-items: stretch;
  height: auto;
}
</style>
